import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./fornecedor-listar/fornecedor-listar.module').then(m => m.FornecedorListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./fornecedor-inserir/fornecedor-inserir.module').then(m => m.FornecedorInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./fornecedor-editar/fornecedor-editar.module').then(m => m.FornecedorEditarModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./fornecedor-detalhar/fornecedor-detalhar.module').then(m => m.FornecedorDetalharModule) }
    ])],
    exports: [RouterModule]
})
export class FornecedorAppRoutingModule { }